@if (isVisible$ | async) {
  <section [ngStyle]="styles" class="no-print">
    @if (labelEnabled) {
      <blaze-element-label
        [color]="props?.style?.general?.title?.color1"
        [extendInputPadding]="elementContext?.extendInputPadding"
        [fontFamily]="props?.style?.labelBlock?.fontFamily"
        [fontSize]="props?.style?.labelBlock?.fontSize"
        [fontStyle]="props?.style?.labelBlock?.fontStyle"
        [fontWeight]="props?.style?.labelBlock?.fontWeight"
        [horizontalAlign]="props?.content?.title?.align"
        [icon]="props?.content?.title?.icon"
        [iconColor]="props?.content?.title?.iconColor?.color1"
        [iconPosition]="props?.content?.title?.iconPosition"
        [iconSize]="props?.style?.labelBlock?.iconSize"
        [isUsingOldPaddingStrategy]="isUsingOldPaddingStrategy"
        [lineHeight]="props?.style?.labelBlock?.lineHeight"
        [position]="props?.content?.title?.position"
        [tooltip]="props?.content?.title?.tooltip"
        [width]="props?.content?.title?.width"
      >
        {{ labelText }}
      </blaze-element-label>
    }
    <div
      #inputEl
      (click)="onInputContainerClick($event)"
      (elementResized)="onResized($event)"
      [ngStyle]="inputWrapperStyles"
      blazeResized
      class="input"
    >
      <input
        #filterInput
        (keyup)="onInputKeyUp($event)"
        autocomplete="off"
        class="filter-input"
        type="text"
      />
      <button
        (menuClosed)="dropdownOpened = false"
        (menuOpened)="dropdownOpened = true"
        [class.inverse]="dropdownOpened"
        [ngStyle]="{ color: dropdownOpened ? accentColor : 'inherit' }"
        class="menu-trigger w-[24px] h-[24px] outline-none"
      >
        <mat-icon svgIcon="icon_chevron_down_16" />
      </button>
      <div
        [matMenuTriggerFor]="menu"
        [matMenuTriggerRestoreFocus]="false"
        class="menu-fake-trigger"
      ></div>
    </div>
    <mat-menu
      #menu="matMenu"
      [overlapTrigger]="false"
      class="accounts-dropdown-menu mat-elevation-z4 {{ elementKeyRoot }} {{ elementKey }}"
      xPosition="before"
      yPosition="below"
    >
      @if ({ options: displayedOptions$ | async }; as context) {
        <ng-template matMenuContent>
          @for (
            item of context.options | slice: 0 : 1000;
            track trackAccountOptions($index, item)
          ) {
            <button
              (click)="onSelect(item)"
              [class.active]="isSelected(item)"
              disableRipple
              mat-menu-item
            >
              {{ getItemLabel(item) }}
              @if (isSelected(item)) {
                <span>✔</span>
              }
            </button>
          }
          @if (context.options?.length === 0) {
            <button class="pointer-events-none no-items-option" disableRipple mat-menu-item>
              No matching accounts found.
            </button>
          }
        </ng-template>
      }
    </mat-menu>
  </section>
}
